import { Breadcrumb } from "@services/ui-components";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { currentBranchIdVar } from "../../../main/globalVar/state";

export const Home = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const currentBranchId = useReactiveVar(currentBranchIdVar);

    useEffect(() => {
        if (currentBranchId) {
            navigate(`/branches/main/branch/${String(currentBranchId)}`, { replace: true });
        }
    }, [currentBranchId, navigate]);

    return (
        <div>
            <h2 className="mb-0">Company</h2>
            <Breadcrumb paths={[{ path: "/", label: t("home") }]} t={t} />
        </div>
    );
};
